import * as React from "react";
import { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { ll_url } from "../../utils/tools";
import FocusIcon from "./components/FocusIcon";
import EssResSelect from "./components/EssResSelect";
import ShowAllInhibitorsCheckbox from "./components/ShowAllInhibitorsCheckbox";
import { Button } from "reactstrap";
import { useViewerContext, ViewerContextProvider } from "./viewer-context";
import { JobInfoContext, JobInfoContextProvider } from "../../job-info-context";
import { diffBodyTemplate } from "../JobPage/components/inhibitor-table/InhibitorBaseTable";
import { exampleJob } from "../../settings";
import RemoveButton from "../../commons/RemoveButton";
import { ViewerInhibitorModal } from "./components/viewer-inhibitor-modal";
import { Helmet } from "react-helmet";
import { MolstarViewerWithContext } from "./molstar-viewer-with-context";
import { dispatchViewerEvent } from "./viewer-event";

function Page() {

  const {id, jobInfo} = useContext(JobInfoContext);

  const {
    annotations,
    wtEnabled, setWtEnabled,
    mutEnabled, setMutEnabled,
    wtMutRes, setWtMutRes,
    mutMutRes, setMutMutRes,
    wtEssRes, setWtEssRes,
    mutEssRes, setMutEssRes,
    wtPockets, setWtPockets,
    mutPockets, setMutPockets,
    representation, setRepresentation,
    essentialResidues, mutatedResidues,
    toggleInhibitorModal,
    selectedInhibitors,
    setSelectedInhibitors,
    wtInhibitors, mutInhibitors,
    setWtInhibitor, setMutInhibitor,
    setAllWtInhibitors, setAllMutInhibitors,
  } = useViewerContext();

  const mutation = annotations?.mutation;

  return (
    <div className="ll-page-molstar">
      <Helmet>
        <title>{`Viewer ${id}`}</title>
      </Helmet>
      {/* <div className="buttons buttons-top">
                <Button>Button</Button>
            </div> */}
      <div className="ll-molstar-viewer-row">
        {/* <div className="buttons buttons-left">
                <Button>Button</Button>
              </div> */}
        <MolstarViewerWithContext />
        <div className="buttons buttons-right">

          <div className="ll-logo-tool">
            <Link to={ll_url('/')}>
              <img src={ll_url('/images/logos/predictonco.svg')} alt="PredictONCO logo" />
            </Link>
          </div>

          <div className="ll-controls-box">
          <table>
            <tbody>
            <tr>
              <td style={{ width: '35%' }}><strong>Job ID</strong></td>
              <td>{id}</td>
            </tr>
            <tr>
              <td><strong>Title</strong></td>
              <td>{jobInfo?.title}</td>
            </tr>
            <tr>
              <td><strong>Protein</strong></td>
              <td>{annotations?.proteinCode}</td>
            </tr>
            <tr>
              <td><strong>Mutation</strong></td>
              <td>{mutation ? `${mutation.wt}${mutation.position}${mutation.mut}` : ''}</td>
            </tr>
            </tbody>
          </table>

            <div className="ll-errors">
            {/*  {!detail && !ReqRes.isEnded(props.fetch.detail) && !state.starting ? (*/}
            {/*    Messages.JOB_INFO_FETCHING()*/}
            {/*  ) : ReqRes.isFailed(props.fetch.detail) ? (*/}
            {/*    Messages.JOB_INFO_FAILED(jobId)*/}
            {/*  ) : (detail?.status !== 5) ? (*/}
            {/*    Messages.VIEWER_WAITING()*/}
            {/*  ) : !annotations && !ReqRes.isEnded(props.fetch.annotations) && !state.starting ? (*/}
            {/*    Messages.VIEWER_ANNOTATIONS_FETCHING()*/}
            {/*  ) : ReqRes.isFailed(props.fetch.annotations) ? (*/}
            {/*    Messages.VIEWER_ANNOTATIONS_FAILED(jobId)*/}
            {/*  ) : null}*/}
            {/*  {props.wt?.protein.loadFailed && (*/}
            {/*    Messages.VIEWER_PROTEIN_FAILED(jobId, 'wild type')*/}
            {/*  )}*/}
            {/*  {props.mut?.protein.loadFailed && (*/}
            {/*    Messages.VIEWER_PROTEIN_FAILED(jobId, 'mutant')*/}
            {/*  )}*/}
            {/*  {anyLigandFailed && (*/}
            {/*    Messages.VIEWER_LIGANDS_FAILED(jobId)*/}
            {/*  )}*/}
            </div>

            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <Link
                to={ll_url(`/job/${id}`)}
                style={{ display: 'inline-block' }}
              ><Button>Back to results</Button></Link>
            </div>

          </div>

          <div className="ll-controls-box"><table>
            <thead>
            <tr>
              <td />
              <td className="ll-center">WT</td>
              <td className="ll-center">Mutant</td>
            </tr>
            </thead>
            <tbody>
            <tr className="ll-row-border">
              <td><h3>Model</h3></td>
              <td className="ll-center">
                <input type="checkbox" checked={wtEnabled} onChange={({ target }) => setWtEnabled(target.checked)} />
              </td>
              <td className="ll-center">
                <input type="checkbox" checked={mutEnabled} onChange={({ target }) => setMutEnabled(target.checked)}/>
              </td>
            </tr>
            <tr className="ll-row-border">
              <td colSpan={3}><h3>Elements</h3></td>
            </tr>
            <tr>
              <td>Mutated residue
                <FocusIcon
                  title="Focus mutated residue"
                  disabled={!((wtEnabled && wtMutRes) || (mutEnabled && mutMutRes))}
                  focus={() => {
                    if (mutatedResidues.length > 0) dispatchViewerEvent('focusResidue', mutatedResidues[0])
                  }}
                />
              </td>
              <td className="ll-center">
                <input
                  type="checkbox"
                  checked={wtEnabled && wtMutRes}
                  onChange={({ target }) => setWtMutRes(target.checked)}
                  disabled={!wtEnabled}
                />
              </td>
              <td className="ll-center">
                <input
                  type="checkbox"
                  checked={mutEnabled && mutMutRes}
                  onChange={({ target }) => setMutMutRes(target.checked)}
                  disabled={!mutEnabled}
                />
              </td>
            </tr>
            <tr>
              <td>
                Essential residues
                <EssResSelect
                  essentialResidues={essentialResidues}
                  disabled={!((wtEnabled && wtEssRes) || (mutEnabled && mutEssRes))}
                  focusResidue={(essRes) => dispatchViewerEvent('focusResidue', essRes)}
                />
              </td>
              <td className="ll-center">
                <input
                  type="checkbox"
                  checked={wtEnabled && wtEssRes}
                  onChange={({ target }) => setWtEssRes(target.checked)}
                  disabled={!wtEnabled}
                />
              </td>
              <td className="ll-center">
                <input
                  type="checkbox"
                  checked={mutEnabled && mutEssRes}
                  onChange={({ target }) => setMutEssRes(target.checked)}
                  disabled={!mutEnabled}
                />
              </td>
            </tr>
            <tr>
              <td>Pockets</td>
              <td className="ll-center">
                <input
                  type="checkbox"
                  checked={wtEnabled && wtPockets}
                  onChange={({ target }) => setWtPockets(target.checked)}
                  disabled={!wtEnabled}
                />
              </td>
              <td className="ll-center">
                <input
                  type="checkbox"
                  checked={mutEnabled && mutPockets}
                  onChange={({ target }) => setMutPockets(target.checked)}
                  disabled={!mutEnabled}
                />
              </td>
            </tr>
            <tr className="ll-row-border">
              <td colSpan={3}><h3>Protein representation</h3></td>
            </tr>
            <tr>
              <td colSpan={3}>
                {([
                  ['cartoon', 'Cartoon'],
                  ['ball-and-stick', 'Sticks'],
                  ['molecular-surface', 'Surface']
                ] as const).map(([repr, reprName]) => {
                  return (
                    <label key={repr}>
                      <input
                        type="radio"
                        checked={representation === repr}
                        onChange={() => setRepresentation(repr)}
                      />
                      {reprName}
                    </label>
                  )
                }).reduce((a, b) => <>{a}<br />{b}</>)}
              </td>
            </tr>
            </tbody>
          </table></div>

          <div className="ll-controls-box">
            <table className="ll-row-border ll-rightside-inhibitor-table">
              <thead>
              <tr>
                <td colSpan={2}><h3>Inhibitors</h3></td>
                {selectedInhibitors && selectedInhibitors.length > 0 && <>
                    <td />
                    <td className="ll-center">
                      <div style={{ display: 'flex' }}>
                        <label title="Show all wild-type inhibitors" style={{ whiteSpace: 'nowrap' }}>
                          <ShowAllInhibitorsCheckbox
                            checkedInhibitors={wtInhibitors}
                            setCheckedInhibitors={setAllWtInhibitors}
                            disabled={!wtEnabled}
                          />
                          <span style={{ fontSize: '0.8em' }}>WT</span>
                        </label>
                      </div>
                    </td>
                    <td className="ll-center">
                      <div style={{ display: 'flex' }}>
                        <label title="Show all mutant inhibitors" style={{ whiteSpace: 'nowrap' }}>
                          <ShowAllInhibitorsCheckbox
                            checkedInhibitors={mutInhibitors}
                            setCheckedInhibitors={setAllMutInhibitors}
                            disabled={!mutEnabled}
                          />
                          <span style={{ fontSize: '0.8em' }}>MUT</span>
                        </label>
                      </div>
                    </td>
                </>}
              </tr>
              </thead>
              <tbody>
              {selectedInhibitors && selectedInhibitors.map(inh => <tr key={inh.id}>
                <td className="ll-wrap-anywhere">
                  {inh.name}
                </td>
                <td className="ll-remove-inhibitor">
                  <RemoveButton
                    title="Remove inhibitor"
                    data={inh.zincId}
                    onClick={() => setSelectedInhibitors(selectedInhibitors => selectedInhibitors.filter(i => i !== inh))}
                  />
                </td>
                <td>
                  <div style={{ display: 'flex' }}>
                    {diffBodyTemplate(inh)}
                  </div>
                </td>
                <td className="ll-center">
                  <div style={{ display: 'flex' }}>
                    <input
                      type="checkbox"
                      onChange={e => setWtInhibitor(inh.id, e.target.checked)}
                      checked={wtEnabled && (wtInhibitors[inh.id] ?? false)}
                      disabled={!wtEnabled}
                    />
                    <FocusIcon
                      title={`Focus ${inh.name} in WT`}
                      disabled={!wtEnabled || !wtInhibitors[inh.id]}
                      focus={() => dispatchViewerEvent('focusWtInhibitor', {inhibitor: inh})}
                    />
                  </div>
                </td>
                <td className="ll-center">
                  <div style={{ display: 'flex' }}>
                    <input
                      type="checkbox"
                      onChange={e => setMutInhibitor(inh.id, e.target.checked)}
                      checked={mutEnabled && (mutInhibitors[inh.id] ?? false)}
                      disabled={!mutEnabled}
                    />
                    <FocusIcon
                      title={`Focus ${inh.name} in Mutant`}
                      disabled={!mutEnabled || !mutInhibitors[inh.id]}
                      focus={() => dispatchViewerEvent('focusMutInhibitor', {inhibitor: inh})}
                    />
                  </div>
                </td>
              </tr>)}
              </tbody>
            </table>
            <Button
              onClick={toggleInhibitorModal}
              style={{ display: 'block', margin: '1rem auto 0' }}
              // disabled={}
            >
              Select inhibitors
            </Button>
          </div>
        </div>
      </div>
      <ViewerInhibitorModal />
    </div>
  )
}

export default function PageWithContext() {
  const params = useParams<{jobId: string}>();
  let id = params['jobId'];
  if (id === exampleJob.jobIdAlias) {
    id = exampleJob.jobId;
  }
  return (
    <JobInfoContextProvider id={id}>
      <ViewerContextProvider>
        <Page />
      </ViewerContextProvider>
    </JobInfoContextProvider>
  )

}
